import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import Footer from '../components/Footer';
import logo from '../assets/logo.png';

interface Props {
  onBack: () => void;
}

export default function PrivacyPage({ onBack }: Props) {
  return (
    <>
      <div className="dashboard">
        <header className="dashboard-header">
          <div className="dashboard-header-nav">
            <button onClick={onBack} className="btn-back">
              <FontAwesomeIcon icon={faArrowLeft} /> Back
            </button>
            <div style={{ width: 70 }} />
          </div>
          <img src={logo} alt="NoWeakWeek" className="dashboard-logo" />
          <h1>Privacy Policy</h1>
        </header>

        <div className="settings-content">
          <div className="settings-section">
            <h2><FontAwesomeIcon icon={faShieldAlt} /> Privacy Policy</h2>
            <p className="settings-description">Effective Date: June 30, 2026</p>

            <p className="settings-description">
              NoWeakWeek ("we", "us", or "our") is a weekly fitness competition app that connects to Strava.
              This Privacy Policy explains how we collect, use, and protect your data.
            </p>

            <h3>1. Data We Collect</h3>
            <p className="settings-description">
              When you sign in with Strava, we collect the following data:
            </p>
            <ul className="settings-delete-list">
              <li><strong>Profile data:</strong> Name, avatar, athlete ID</li>
              <li><strong>Activity data:</strong> Workout types, durations, distances, heart rate data, elevation gain</li>
              <li><strong>Heart rate zones:</strong> Your personal Strava heart rate zone thresholds</li>
              <li><strong>Calculated data:</strong> Points, ELO rating, match results, level progression</li>
            </ul>

            <h3>2. How We Use Your Data</h3>
            <ul className="settings-delete-list">
              <li>To calculate your training points based on heart rate zones</li>
              <li>To match you with opponents of similar skill level</li>
              <li>To display your profile and match results within the app</li>
              <li>To generate opponent profiles using only your own data</li>
            </ul>

            <h3>3. Data Storage & Security</h3>
            <p className="settings-description">
              Your data is stored on encrypted MySQL databases hosted in the EU (Austria).
              We use HTTPS for all data transmission. Access to the database is restricted and monitored.
            </p>

            <h3>4. Data Sharing</h3>
            <p className="settings-description">
              We do <strong>not</strong> sell, license, or share your data with any third parties.
              Your data is only used within the NoWeakWeek application.
              Your opponent sees only your calculated points and basic profile (name, avatar, level) — never your raw activity data.
            </p>

            <h3>5. Data Retention</h3>
            <p className="settings-description">
              We retain your data as long as your account is active.
              When you delete your account, all personal data, activities, and match history are permanently deleted.
            </p>

            <h3>6. Your Rights</h3>
            <ul className="settings-delete-list">
              <li><strong>Access:</strong> You can view all your data in the app</li>
              <li><strong>Deletion:</strong> You can delete your account and all data via Settings</li>
              <li><strong>Revoke Strava access:</strong> You can revoke our access anytime in your Strava account settings (strava.com/settings/apps) or via the Delete Account feature</li>
            </ul>

            <h3>7. Strava Data</h3>
            <p className="settings-description">
              We access your Strava data via the Strava API under Strava's API Agreement.
              Your data is processed according to Strava's
              <a href="https://www.strava.com/legal/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#6ba3ff' }}> Privacy Policy</a> and
              <a href="https://www.strava.com/legal/api" target="_blank" rel="noopener noreferrer" style={{ color: '#6ba3ff' }}> API Agreement</a>.
            </p>

            <h3>8. Cookies</h3>
            <p className="settings-description">
              We use only essential cookies required for authentication (OAuth state tokens).
              No tracking or analytics cookies are set by our application.
            </p>

            <h3>9. Changes to This Policy</h3>
            <p className="settings-description">
              We may update this Privacy Policy from time to time.
              Changes will be reflected on this page with an updated effective date.
            </p>

            <h3>10. Contact</h3>
            <p className="settings-description">
              For privacy-related questions, contact us at:
              <a href="mailto:office@vienom.com" style={{ color: '#6ba3ff' }}> office@vienom.com</a>
            </p>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
